/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetLocationCombos200Response,
  GetLocationModifierGroups200Response,
  GetLocationModifiers200Response,
  GetLocationProducts200Response,
  GetProductsFiltersParameterInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  UpdateLocationComboRequest,
  UpdateLocationCombosRequestInner,
  UpdateLocationProductRequest,
  UpdateLocationProductsRequestInner,
} from '../models/index';
import {
    GetLocationCombos200ResponseFromJSON,
    GetLocationCombos200ResponseToJSON,
    GetLocationModifierGroups200ResponseFromJSON,
    GetLocationModifierGroups200ResponseToJSON,
    GetLocationModifiers200ResponseFromJSON,
    GetLocationModifiers200ResponseToJSON,
    GetLocationProducts200ResponseFromJSON,
    GetLocationProducts200ResponseToJSON,
    GetProductsFiltersParameterInnerFromJSON,
    GetProductsFiltersParameterInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    UpdateLocationComboRequestFromJSON,
    UpdateLocationComboRequestToJSON,
    UpdateLocationCombosRequestInnerFromJSON,
    UpdateLocationCombosRequestInnerToJSON,
    UpdateLocationProductRequestFromJSON,
    UpdateLocationProductRequestToJSON,
    UpdateLocationProductsRequestInnerFromJSON,
    UpdateLocationProductsRequestInnerToJSON,
} from '../models/index';

export interface GetLocationCombosRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<GetProductsFiltersParameterInner>;
    sorting?: Array<GetProductsSortingParameterInner>;
}

export interface GetLocationModifierGroupsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<GetProductsFiltersParameterInner>;
    sorting?: Array<GetProductsSortingParameterInner>;
}

export interface GetLocationModifiersRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<GetProductsFiltersParameterInner>;
    sorting?: Array<GetProductsSortingParameterInner>;
}

export interface GetLocationProductsRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<GetProductsFiltersParameterInner>;
    sorting?: Array<GetProductsSortingParameterInner>;
}

export interface UpdateLocationComboOperationRequest {
    comboId: string;
    updateLocationComboRequest: UpdateLocationComboRequest;
}

export interface UpdateLocationCombosRequest {
    updateLocationCombosRequestInner?: Array<UpdateLocationCombosRequestInner>;
}

export interface UpdateLocationModifierRequest {
    modifierId: string;
    updateLocationComboRequest: UpdateLocationComboRequest;
}

export interface UpdateLocationModifierGroupRequest {
    modifierGroupId: string;
    updateLocationComboRequest: UpdateLocationComboRequest;
}

export interface UpdateLocationModifierGroupsRequest {
    updateLocationCombosRequestInner?: Array<UpdateLocationCombosRequestInner>;
}

export interface UpdateLocationModifiersRequest {
    updateLocationCombosRequestInner?: Array<UpdateLocationCombosRequestInner>;
}

export interface UpdateLocationProductOperationRequest {
    productId: string;
    updateLocationProductRequest?: UpdateLocationProductRequest;
}

export interface UpdateLocationProductsRequest {
    updateLocationProductsRequestInner?: Array<UpdateLocationProductsRequestInner>;
}

/**
 * 
 */
export class LocationCatalogApi extends runtime.BaseAPI {

    /**
     */
    async getLocationCombosRaw(requestParameters: GetLocationCombosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLocationCombos200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/location/combos`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLocationCombos200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLocationCombos(requestParameters: GetLocationCombosRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLocationCombos200Response> {
        const response = await this.getLocationCombosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationModifierGroupsRaw(requestParameters: GetLocationModifierGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLocationModifierGroups200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/location/modifier-groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLocationModifierGroups200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLocationModifierGroups(requestParameters: GetLocationModifierGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLocationModifierGroups200Response> {
        const response = await this.getLocationModifierGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationModifiersRaw(requestParameters: GetLocationModifiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLocationModifiers200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/location/modifiers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLocationModifiers200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLocationModifiers(requestParameters: GetLocationModifiersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLocationModifiers200Response> {
        const response = await this.getLocationModifiersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocationProductsRaw(requestParameters: GetLocationProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLocationProducts200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/catalogs/location/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLocationProducts200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLocationProducts(requestParameters: GetLocationProductsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLocationProducts200Response> {
        const response = await this.getLocationProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateLocationComboRaw(requestParameters: UpdateLocationComboOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['comboId'] == null) {
            throw new runtime.RequiredError(
                'comboId',
                'Required parameter "comboId" was null or undefined when calling updateLocationCombo().'
            );
        }

        if (requestParameters['updateLocationComboRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationComboRequest',
                'Required parameter "updateLocationComboRequest" was null or undefined when calling updateLocationCombo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/location/combo/{comboId}`.replace(`{${"comboId"}}`, encodeURIComponent(String(requestParameters['comboId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationComboRequestToJSON(requestParameters['updateLocationComboRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationCombo(requestParameters: UpdateLocationComboOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationComboRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLocationCombosRaw(requestParameters: UpdateLocationCombosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/location/combos`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateLocationCombosRequestInner']!.map(UpdateLocationCombosRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationCombos(requestParameters: UpdateLocationCombosRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationCombosRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLocationModifierRaw(requestParameters: UpdateLocationModifierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['modifierId'] == null) {
            throw new runtime.RequiredError(
                'modifierId',
                'Required parameter "modifierId" was null or undefined when calling updateLocationModifier().'
            );
        }

        if (requestParameters['updateLocationComboRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationComboRequest',
                'Required parameter "updateLocationComboRequest" was null or undefined when calling updateLocationModifier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/location/modifier/{modifierId}`.replace(`{${"modifierId"}}`, encodeURIComponent(String(requestParameters['modifierId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationComboRequestToJSON(requestParameters['updateLocationComboRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationModifier(requestParameters: UpdateLocationModifierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationModifierRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLocationModifierGroupRaw(requestParameters: UpdateLocationModifierGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['modifierGroupId'] == null) {
            throw new runtime.RequiredError(
                'modifierGroupId',
                'Required parameter "modifierGroupId" was null or undefined when calling updateLocationModifierGroup().'
            );
        }

        if (requestParameters['updateLocationComboRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLocationComboRequest',
                'Required parameter "updateLocationComboRequest" was null or undefined when calling updateLocationModifierGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/location/modifier-group/{modifierGroupId}`.replace(`{${"modifierGroupId"}}`, encodeURIComponent(String(requestParameters['modifierGroupId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationComboRequestToJSON(requestParameters['updateLocationComboRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationModifierGroup(requestParameters: UpdateLocationModifierGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationModifierGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLocationModifierGroupsRaw(requestParameters: UpdateLocationModifierGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/location/modifier-groups`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateLocationCombosRequestInner']!.map(UpdateLocationCombosRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationModifierGroups(requestParameters: UpdateLocationModifierGroupsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationModifierGroupsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLocationModifiersRaw(requestParameters: UpdateLocationModifiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/location/modifiers`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateLocationCombosRequestInner']!.map(UpdateLocationCombosRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationModifiers(requestParameters: UpdateLocationModifiersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationModifiersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLocationProductRaw(requestParameters: UpdateLocationProductOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling updateLocationProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/location/products/{productId}`.replace(`{${"productId"}}`, encodeURIComponent(String(requestParameters['productId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLocationProductRequestToJSON(requestParameters['updateLocationProductRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationProduct(requestParameters: UpdateLocationProductOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationProductRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLocationProductsRaw(requestParameters: UpdateLocationProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/catalogs/location/products`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updateLocationProductsRequestInner']!.map(UpdateLocationProductsRequestInnerToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLocationProducts(requestParameters: UpdateLocationProductsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLocationProductsRaw(requestParameters, initOverrides);
    }

}
